import React, { useState } from 'react';
import api from '../api';

const Auth = ({ setToken }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const endpoint = isLogin ? '/user/login' : '/user/signup';
    const payload = isLogin ? { email, password } : { email, password, name };

    try {
      const res = await api.post(endpoint, payload);
      if (isLogin) {
        localStorage.setItem('token', res.data.token);
        setToken(res.data.token);
      } else {
        alert("Account created! Now please log in.");
        setIsLogin(true);
      }
    } catch (err) {
      alert(err.response?.data?.error || "Auth failed!");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-ink-shell p-4">
      <div className="w-full max-w-md bg-ink-card p-8 rounded-3xl shadow-xl border border-white/10 text-center">
        <h2 className="text-3xl font-serif text-ink-fg mb-6 tracking-tight">
          {isLogin ? 'Welcome Back' : 'Create Account'}
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          {!isLogin && (
            <input
              type="text"
              placeholder="Your Name"
              onChange={e => setName(e.target.value)}
              className="w-full bg-ink-card2 border border-white/10 text-ink-fg rounded-xl px-4 py-3 focus:ring-2 focus:ring-mint outline-none transition-all placeholder:text-ink-fg/30"
              required
            />
          )}
          <input
            type="email"
            placeholder="Email Address"
            onChange={e => setEmail(e.target.value)}
            className="w-full bg-ink-card2 border border-white/10 text-ink-fg rounded-xl px-4 py-3 focus:ring-2 focus:ring-mint outline-none transition-all placeholder:text-ink-fg/30"
            required
          />
          <input
            type="password"
            placeholder="Password"
            onChange={e => setPassword(e.target.value)}
            className="w-full bg-ink-card2 border border-white/10 text-ink-fg rounded-xl px-4 py-3 focus:ring-2 focus:ring-mint outline-none transition-all placeholder:text-ink-fg/30"
            required
          />
          <button
            type="submit"
            className="w-full bg-mint hover:brightness-95 text-ink-shell font-semibold py-3 rounded-xl shadow-md transition-all active:scale-95 mt-2"
          >
            {isLogin ? 'Log In' : 'Sign Up'}
          </button>
        </form>
        <p
          onClick={() => setIsLogin(!isLogin)}
          className="mt-6 text-mint font-medium cursor-pointer hover:text-ink-fg transition-colors"
        >
          {isLogin ? "Don't have an account? Sign up" : "Already have an account? Log in"}
        </p>
      </div>
    </div>
  );
};

export default Auth;
